module.exports = __webpack_public_path__ + "img/b.668ccfa2.svg";